import { Link } from 'react-router-dom';
import { donationContent } from '@/mocks/home';

export default function DonationCTA() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20uplifting%20abstract%20background%20with%20soft%20amber%20and%20cream%20gradients%2C%20gentle%20geometric%20patterns%2C%20hopeful%20radiant%20light%20center%2C%20clean%20minimal%20aesthetic%2C%20inspiring%20atmosphere%2C%20warm%20tones&width=1800&height=800&seq=donation-cta-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/95 via-background-50/80 to-background-50/95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider uppercase text-primary-600 mb-4">
          <i className="ri-heart-line text-sm"></i>
          Support Our Cause
        </span>
        <h2 className="font-heading font-bold text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
          {donationContent.title}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-xl mx-auto">
          {donationContent.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/donation"
            className="px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap flex items-center gap-2"
          >
            {donationContent.cta}
            <i className="ri-arrow-right-line"></i>
          </Link>
          <a
            href="#contact"
            className="px-8 py-3.5 rounded-full border-2 border-secondary-300 hover:border-secondary-400 text-foreground-800 font-semibold text-sm transition-all duration-200 whitespace-nowrap"
          >
            Volunteer With Us
          </a>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10">
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-shield-check-line text-base text-accent-600"></i>
            Registered NGO
          </div>
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-user-smile-line text-base text-accent-600"></i>
            500+ Youth Served
          </div>
          <div className="flex items-center gap-2 text-foreground-500 text-xs">
            <i className="ri-calendar-check-line text-base text-accent-600"></i>
            8+ Years Running
          </div>
        </div>
      </div>
    </section>
  );
}